import Loader from "./Loader";
export default class IdentityLoader extends Loader {
  load() {
    return Promise.resolve(this.src);
  }

}


//////////////////
// WEBPACK FOOTER
// ./~/waveform-playlist/lib/track/loader/IdentityLoader.js
// module id = 1106
// module chunks = 7